import React from 'react';
import { commonStyles } from './styles';
import { UI_TEXT } from '../../../../../utils/constants';

export function ModeIndicator({ isShowMode }) {
    return (
        <div style={{
            position: 'absolute',
            top: '50%',
            right: '2rem',
            transform: 'rotate(90deg) translateY(-450%) translateX(0%)',
            transformOrigin: 'center center',
            background: isShowMode ? 'rgba(0, 0, 0, 0.4)' : 'rgba(0, 255, 163, 0.4)',
            color: isShowMode ? 'rgba(0, 255, 163, 0.8)' : 'rgba(0, 0, 0, 0.8)',
            padding: '0.5rem 1rem',
            borderRadius: '4px',
            fontSize: '0.75rem',
            fontWeight: '500',
            opacity: 0.6,
            pointerEvents: 'none',
            zIndex: 3,
            backdropFilter: 'blur(8px)',
            border: isShowMode ? '1px solid rgba(0, 255, 163, 0.3)' : '1px solid rgba(0, 255, 163, 0.5)',
            textTransform: 'uppercase',
            letterSpacing: '0.3px'
        }}>
            {isShowMode ? UI_TEXT.showMode : UI_TEXT.editMode}
        </div>
    );
} 